import { render } from "./ExamEdit.vue?vue&type=template&id=21947ef0&scoped=true"
import script from "./ExamEdit.vue?vue&type=script&lang=js"
export * from "./ExamEdit.vue?vue&type=script&lang=js"

import "./ExamEdit.vue?vue&type=style&index=0&id=21947ef0&lang=less&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21947ef0"]])

export default __exports__